// @flow

import React, { Component } from "react";
import onClickOutside from "react-onclickoutside";

import List from "./List";
import { PositionTop as StyledSearch } from "src/styles/box";

type Props = {
  focus: number,
  text: string,
  result: Array<Object>,
  outerRef: any,
  handleClose: Function,
  setFocus: Function,
  handleSelect: Function,
  handleInvite: Function,
  noInvite: boolean,
  renderOptions: Function,
};

class Result extends Component<Props> {
  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown, false);
  }

  handleClickOutside = (e) => {
    const { outerRef, handleClose } = this.props;
    if (outerRef) {
      if (!outerRef.contains(e.target)) {
        handleClose();
      }
    }
  };

  handleKeyDown = (event: any) => {
    // Close Search when esc is pressed
    if (event.keyCode === 27) {
      const { handleClose } = this.props;
      handleClose();
    }

    if (event.keyCode === 38) {
      const { setFocus } = this.props;
      setFocus("up");
      event.preventDefault();
    }

    if (event.keyCode === 40) {
      const { setFocus } = this.props;
      setFocus("down");
      event.preventDefault();
    }
  };

  render() {
    const {
      text,
      focus,
      result,
      outerRef,
      handleSelect,
      handleInvite,
      noInvite,
      renderOptions,
    } = this.props;

    return (
      <StyledSearch>
        <List
          text={text}
          focus={focus}
          result={result}
          outerRef={outerRef}
          handleSelect={handleSelect}
          handleInvite={handleInvite}
          noInvite={noInvite}
          renderOptions={renderOptions}
        />
      </StyledSearch>
    );
  }
}

export default onClickOutside(Result);
